import React from 'react';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import styles from './index.module.css';

function CapitalTerms3rdDetailPage(): JSX.Element {
  const brand = import.meta.env.VITE_BRAND as 'KIA' | 'HYUNDAI' | 'GENESIS';
  const {t} = useInferableTranslation();
  const {backOrClose} = useCcWebviewUtilsHelper();

  const WORDS = {
    KIA: {
      name: '기아 대표사이트',
      company: '기아',
      appName: 'Kia',
      agreeCode: 'SW10ZGM005',
    },
    HYUNDAI: {
      name: '현대자동차 온라인 서비스 (웹/앱)',
      company: '현대자동차',
      appName: '마이현대',
      agreeCode: 'SW10ZGP005',
    },
    GENESIS: {
      name: '제네시스 온라인 서비스 (웹/앱)',
      company: '현대자동차',
      appName: 'MY GENESIS',
      agreeCode: 'SW10ZGQ005',
    },
  };

  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header right={<HeaderCloseButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T30199')}</h1>
      </Header>
      <main className="content">
        <section className="section section_mileage_consent">
          <div className="section_heading">
            <h2 className="section_heading_title">내 차 금융관리 서비스를 위한 개인 정보 필수 제공 동의서</h2>
          </div>
          <div className="mileage_consent_detail">
            {/*start 이하 전달받은 약관*/}
            <div className={styles.terms_wrap}>
              <p className={styles.sub_tit}>현대캐피탈 주식회사 귀중</p>
              <p style={{fontSize: 14}}>
                귀하는 개인정보 제공 동의에 대해 거부하실 수 있습니다. 다만, 개인정보 제공에 관한 동의는 내 차 금융관리 서비스와 직접적으로
                관련된 필수적 사항이므로, 아래의 사항에 동의하여야만 내 차 금융관리 서비스 이용이 가능합니다.
              </p>
              <h2
                className={styles.table_tit}
                style={{fontSize: 20}}
              >
                제공에 관한 사항
              </h2>
              <table className={styles.table_basic}>
                <tbody>
                  <tr>
                    <th
                      className={styles.align_left}
                      style={{fontSize: 14}}
                    >
                      제공받는 자
                    </th>
                    <td>
                      <p className={[styles.txt_bold, styles.txt_underline].join(' ')}>{WORDS[brand].company}㈜</p>
                    </td>
                  </tr>
                  <tr>
                    <th
                      className={styles.align_left}
                      style={{fontSize: 14}}
                    >
                      제공받는 자의 이용목적
                    </th>
                    <td>
                      <p className={[styles.txt_bold, styles.txt_underline].join(' ')}>
                        1. {WORDS[brand].appName} 내 차 금융관리 서비스 제공
                      </p>
                      <ul className={styles.lst_dash}>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>내 차 금융관리 서비스 제공을 위한 고객식별</li>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>
                          내 차 금융관리 서비스의 제공(맞춤형 서비스 제공을 위한 고객 분석 및 통계 분석) 및 관리
                        </li>
                      </ul>
                      <p className={[styles.txt_bold, styles.txt_underline].join(' ')}>2. 서비스 이용자 관리 및 민원 대응</p>
                      <ul className={styles.lst_dash}>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>
                          내 차 금융관리 서비스 관련 민원 및 문의사항 처리
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <th
                      className={styles.align_left}
                      style={{fontSize: 14}}
                    >
                      제공받는 자의 보유 및 이용기간
                    </th>
                    <td className={[styles.txt_bold, styles.txt_underline].join(' ')}>
                      <ol className={styles.lst_num}>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>해당 동의 철회</li>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>내 차 금융관리 서비스 탈퇴</li>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>{WORDS[brand].name} 탈퇴</li>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>현대캐피탈 자산관리 서비스 탈퇴</li>
                        <li className={[styles.txt_bold, styles.txt_underline].join(' ')}>현대캐피탈 플러스멤버십 탈퇴</li>
                      </ol>
                      <p className={[styles.txt_bold, styles.txt_underline, styles.pdt0].join(' ')}>위 5개 경우 중 1개 이상 해당 시까지</p>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h2
                className=""
                style={{fontSize: 16}}
              >
                제공 항목
              </h2>
              <table
                className={styles.table_basic}
                style={{fontSize: 14}}
              >
                <colgroup>
                  <col width="35%" />
                  <col width="65%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th rowSpan={2}>
                      <p className={styles.align_left}>제공 항목</p>
                    </th>
                    <td>
                      <p>CI, 고유번호, 차대번호, 차량번호</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                className={styles.info_box}
                style={{fontSize: 14}}
              >
                <p>
                  ※ 현대캐피탈 앱 또는 {WORDS[brand].appName} 앱에서 위 동의에 따른 마이데이터 제3자 제공 내역 확인 및 위 동의를 철회할 수
                  있습니다.
                </p>
                <p>※ 위 동의에 따라 제휴사에 정보를 유상으로 제공할 수 있습니다.</p>
              </div>
              <p
                className={styles.agree_code}
                style={{fontSize: 14}}
              >
                {WORDS[brand].agreeCode}
              </p>
            </div>
            {/*end 이하 전달받은 약관*/}
          </div>
        </section>
      </main>

      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={() => backOrClose()}
        >
          {t('T10114')}
        </button>
      </div>
    </div>
  );
}

export default CapitalTerms3rdDetailPage;
